// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Handler } from "@insite/client-framework/HandlerCreator";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import loadAddressFields from "@insite/client-framework/Store/Data/AddressFields/Handlers/LoadAddressFields";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import {
    getCurrentPromotionsDataView,
    getPromotionsDataView,
} from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import { chain, LoadData } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/LoadDataIfNeeded";

type HandlerType = Handler<{
    cartId?: string;
    onSuccess?: () => void;
}>;

export const XngLoadData: HandlerType = props => {
    const state = props.getState();
    if (!getCurrentCountries(state)) {
        props.dispatch(loadCurrentCountries());
    }
    if (!getAddressFieldsDataView(state).value) {
        props.dispatch(loadAddressFields());
    }

    const { cartId } = props.parameter;
    const expand = state.data.carts.cartApiParameter?.expand || [];
    if (cartId) {
        const cartState = getCartState(state, cartId);
        if ((!cartState.value || !expand.includes("shipping") || !expand.includes("tax")) && !cartState.isLoading) {
            const promotionsState = getPromotionsDataView(state, cartId);
            const shouldLoadPromotions = !promotionsState.value && !promotionsState.isLoading;
            // XNG-Change : add time for get cart by id
            props.dispatch(
                loadCart({
                    cartId,
                    getPromotions: shouldLoadPromotions,
                    shouldLoadFullCart: true,
                    sendTimestamp: true,
                } as any),
            );
        }
    } else {
        const currentCartState = getCurrentCartState(state);
        if (
            (!currentCartState.value ||
                (currentCartState.value.lineCount && !currentCartState.value.cartLines?.length) ||
                !currentCartState.value.carriers ||
                !expand.includes("shipping") ||
                !expand.includes("tax")) &&
            !currentCartState.isLoading
        ) {
            const currentPromotionsState = getCurrentPromotionsDataView(state);
            const shouldLoadPromotions = !currentPromotionsState.value && !currentPromotionsState.isLoading;
            props.dispatch(loadCurrentCart({ getPromotions: shouldLoadPromotions, shouldLoadFullCart: true }));
        }
    }
};

replaceInChain(chain, LoadData, XngLoadData);
